import ApiBase from '../ApiBase';

// Check out the Duality Portal "Add Version Control to Model" Wiki for guidance.

class VersionHistory extends ApiBase {
    route = '/version-history';
}

export default new VersionHistory();
